import { faker } from '@faker-js/faker'

export const SITE_USER_INSTRUCTORS_MOCK_RESPONSE = {
  data: {
    sitesCoreUserInstructors: [
      {
        id: faker.string.uuid(),
        v1Id: Number(faker.string.numeric(1)),
        firstName: faker.lorem.word(),
        lastName: faker.lorem.word(),
        status: faker.datatype.boolean(),
      },
    ],
  },
}
